import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'

// initial state
const state = {
  siteSettings: {
    menuItems: [],
  },
  submissionThresholds: {},
}

// getters
const getters = {
  getAll: (state) => () => {
    return state.siteSettings
  },
  getSubmissionThresholds: (state) => () => {
    return (!state.submissionThresholds) ? undefined : state.siteSettings.submissionThresholds
  },
}

// actions
const actions = {
  bindSiteSettings: firebaseAction(context => {
    return context.bindFirebaseRef('siteSettings', db.ref('site-settings'))
  }),
  updateMenuLinks ({ commit }, menuLinks) {
    commit('setMenuLinks', menuLinks)
    db.ref('site-settings/menuItems').set(menuLinks)
  },
}

// mutations
const mutations = {
  setMenuLinks (state, menuLinks) {
    state.siteSettings.menuItems = menuLinks
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
